import { AgentProfileType } from '@shared/services/apiService';

export interface AddAgentPromptFormValue {
  name: string;
  prompt: string;
  firstMessage: string;
  firstMessageInterruptionsEnabled: boolean;
}

export const AddAPTab = {
  SELECT_AP: 'selectAP',
  AP_FORM: 'APForm',
} as const;

export const AgentProfileTypeEnum: Record<Uppercase<AgentProfileType>, AgentProfileType> = {
  CUSTOM: 'custom',
  SYSTEM: 'system',
  'CUSTOMER-TEMPLATE': 'customer-template',
} as const;

export type AddAPTab = (typeof AddAPTab)[keyof typeof AddAPTab];
